/**
 * Shared URL checks for values that end up in an `href` or get sent to the API.
 *
 * Mirrors the private validator in RepositoryManagement so the two agree on what
 * counts as a usable link.
 */

/**
 * True only for a well-formed absolute http(s) URL.
 *
 * Rejects the schemes that make a rendered link dangerous (`javascript:`,
 * `data:`, `vbscript:`) and schemeless values like `//evil.com` or
 * `www.example.com`, which `new URL` cannot parse without a base and which would
 * otherwise render as a broken relative link.
 */
export const isHttpUrl = (value: string): boolean => {
  if (!value) return false;
  try {
    const { protocol } = new URL(value.trim());
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
};

export const invalidUrlMessage = (): string =>
  'Enter a valid URL starting with http:// or https://';
